import "./Fields.css";

import React, { Component } from "react";

import Api from "../services/api";
import AuthService from "../services/auth";
import moment from "moment";

class ProfileSubscriptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        status: -2
      }
    };
  }

  componentDidMount() {
    new Api()
      .get("/users/current", {}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          user: response.user
        });
      });
  }

  handleCancelSubscription(e) {
    e.preventDefault();

    new Api()
      .post(`/payment/cancel-subscription`, {}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          user: response.user
        });
      });
  }

  render() {
    const { title } = this.props;
    const { user } = this.state;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">{title}</div>
        <form>
          {user.status > -2 && (
            <div className="field-container text">
              {user.status === 3 && (
                <div className="field-title">
                  Your subscription is {!user.subscriptionCancelled && "active"}{" "}
                  {user.subscriptionCancelled &&
                    `cancelled, it will end at ${moment
                      .utc(user.periodEnd)
                      .local()
                      .format("YYYY-MM-DD HH:mm")}`}
                </div>
              )}
              {user.status !== 3 && (
                <div className="field-title">
                  Your subscription is not active
                </div>
              )}
              {!user.subscriptionCancelled && user.status === 3 && (
                <button
                  className="btn submit"
                  onClick={e => {
                    this.handleCancelSubscription(e);
                  }}
                >
                  Cancel subscription
                </button>
              )}
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default ProfileSubscriptions;



// WEBPACK FOOTER //
// ./src/components/ProfileSubscriptions.js